module.exports = __webpack_public_path__ + "static/staff-logo-a528e594e756f1f44fd5130b9a2d574c.png";